import styled from 'styled-components';
import { Tooltip } from 'antd';
import { MoreDropDown } from '@components/common';

export const StyledDropDown = styled(MoreDropDown)`
  border: none;
  box-shadow: none;
  background: transparent;

  &:hover,
  &:focus {
    background: transparent;
  }
`;

export const Title = styled.h2`
  min-width: 260px;
  font-weight: 300;
  font-size: 18px;
  border-bottom: 1px solid #9b9b9b;
  color: #4a4a4a;
  display: flex;
  align-items: center;
  padding-bottom: 5px;

  ::before {
    content: '';
    display: inline-block;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: #9b9b9b;
    border: 1px solid #4a4a4a;
    margin-right: 8px;
    margin-left: 12px;
  }
`;

export const AlertName = styled.span`
  display: inline-block;
  max-width: 200px;
  min-width: 200px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const SubTitle = styled.h4`
  margin-bottom: 0;
  font-size: 12px;
  font-weight: 300;
  color: gray;
`;

export const Text = styled.div`
  margin-bottom: 8px;
`;

export const Info = styled.div`
  margin-left: 13px;
`;

export const Wrapper = styled.div`
  padding: 8px 10px;
  margin-left: -70px;
  width: 280px;
  font-size: 16px;
  background-color: #f1f7ff;
  z-index: 0;
`;

export const AiAlertText = styled.div`
  margin-bottom: 4px;
  font-size: 13px;
`;

export const LineWrapper = styled.div`
  border-top: solid 1px #000;
  opacity: 0.3;
  padding-bottom: 2px;
`;

export const AiAlertInfoWrapper = styled.div`
  padding: 8px 10px;
  margin-left: -70px;
  width: 350px;
  font-size: 14px;
  background-color: #f1f7ff;
  z-index: 0;
`;

export const AlertSubTitle = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: #9b9b9b;
`;

export const AlertStatusBox = styled.div`
  background: #979797;
  border-radius: 5px;
  font-weight: 600;
  font-size: 10px;
  color: #fff;
  padding: 5px;
  box-sizing: border-box;
  margin-bottom: 2px;
`;

export const AlertText = styled.div`
  margin-bottom: 8px;
  display: flex;
  justify-content: left;
  align-items: center;
`;

export const StyledToolTip = styled(Tooltip)`
  margin: 3px;
  padding-left: 2px;
`;
